module.exports = __webpack_public_path__ + "static/media/hydroponics_systems_net_pots4.d923c306.webp";